<template>
  <div class="product-derectory-ban">
    <el-carousel arrow="never" :autoplay="false" ref="carousel" :indicator-position="getTabsLength > 1 ? 'inside' : 'none'" v-if="menu !== 'pd'">
      <el-carousel-item v-for="(img, index) in urls" :key="index" :style="{flex: currentIndex === index ? 1 : 0}">
        <div style="display:flex">
          <img class="img1" :src="img"/>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel class="sub-carousel" arrow="never" :loop="true" :autoplay="true" ref="carousel" :indicator-position="getTabsLength > 1 ? 'inside' : 'none'" trigger="hover" v-else @change="(i) => subCarouselChange(i)">
      <el-carousel-item v-for="(img, index) in urls[currentIndex]" :key="index" :style="{flex: sub_carousel_index === index ? 1 : 0}">
        <div style="display:flex">
          <img class="img1" :src="img" style="object-fit: contain;"/>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="body-container ban-container">
      <div :class="{mark: true, 'is-active': item.isActive}" v-for="(item, index) in tabs" :key="index"
        style="cursor: default" @click="onClick(item, index)">
        <p v-if="language === '2'">{{item.titleEN}}</p>
        <p v-else>{{item.title}}</p>
        <p v-if="item.subTitle">
          {{item.subTitle}}
          <span>·</span>
          {{item.subTitleEN}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    urls: {
      type: Array
    },
    menu: String,
    tabs: {
      type: Array,
      default: () => {
        return [{
          title: '',
          titleEN: '',
          subTitle: '',
          subTitleEN: '',
          isActive: false
        }]
      }
    },
    height: {
      type: Number
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    },
    getTabsLength () {
      if (this.tabs) {
        return this.tabs.length
      }
      return 0
    }
  },
  data () {
    return {
      currentIndex: 0,
      sub_carousel_index: 0
    }
  },
  methods: {
    onClick (item, index) {
      this.currentIndex = index
      this.$refs.carousel.setActiveItem(index)
      let a = this.tabs.find(t => t.isActive)
      if (a) {
        a.isActive = false
      }
      item.isActive = true
      this.$emit('change', item, index)
    },
    subCarouselChange (i) {
      this.sub_carousel_index = i
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/default.scss';

.product-derectory-ban {
  width: 100%;
  overflow: hidden;
  position: relative;
  ::v-deep .el-carousel {
    height: 100%;
    overflow: initial;
    display: flex;
    .el-carousel__indicators--horizontal {
      z-index: 11;
    }
    .el-carousel__container {
      height: auto;
      overflow: initial;
      display: inline-flex;
      .el-carousel__item {
        width: 100%;
        position: relative;
        height: auto;
        overflow: initial;
        .img1 {
          width: 100%;
          padding: 0;
          margin: 0;
          ::before, ::after {
            height: 0;
          }
        }
      }
    }
  }

  .banner-img {
    width: 100%;
  }

  .ban-container {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 10;
  }

  .mark {
    padding-top: 20px;
    padding-bottom: 20px;
    color: #666;
    background-color: rgba(255, 255, 255, .7);
    text-align: center;
    width: 180px;

    &.is-active {
      background: rgba($color: $about-color, $alpha: 1);
      color: $white-color;
    }

    p {
      &:nth-of-type(1) {
        font-size: 18px;
        // margin-bottom: 5px;
        // font-weight: 700;
      }

      // &:nth-of-type(2) {
      //   // margin-bottom: 20px;
      //   font-size: 18px;
      // }

      &:nth-of-type(2) {
        border: 1px solid $white-color;
        padding: 2px 5px;
      }

      span {
        padding: 0 5px;
      }
    }
  }
}
</style>
